// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var A1Notation = require("@segment/a1-notation");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");
var DataDependency$SmartcutsMacros = require("./shared/DataDependency.bs.js");
var GoogleSheetTypes$SmartcutsMacros = require("../GoogleSheetTypes.bs.js");
var GoogleSheetHelpers$SmartcutsMacros = require("../GoogleSheetHelpers.bs.js");

function columnForIndexStarting0(colIndex) {
  return A1Notation.toCol(colIndex + 1 | 0);
}

function fromRowColStarting0(rowIndex, colIndex) {
  return new A1Notation(colIndex + 1 | 0, rowIndex + 1 | 0).toString();
}

var A1 = {
  columnForIndexStarting0: columnForIndexStarting0,
  fromRowColStarting0: fromRowColStarting0
};

function t_encode(encoder_rowLocation, v) {
  return Js_dict.fromArray([
              [
                "rowLocation",
                Curry._1(encoder_rowLocation, v.rowLocation)
              ],
              [
                "cellValues",
                Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.cellValues)
              ]
            ]);
}

function t_decode(decoder_rowLocation, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var rowLocation = Curry._1(decoder_rowLocation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowLocation"), null));
  if (rowLocation.TAG === /* Ok */0) {
    var cellValues = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "cellValues"), null));
    if (cellValues.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                rowLocation: rowLocation._0,
                cellValues: cellValues._0
              }
            };
    }
    var e = cellValues._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".cellValues" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = rowLocation._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".rowLocation" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify(stringifyRowLocation, param) {
  return "{ rowLocation: " + (Curry._1(stringifyRowLocation, param.rowLocation) + (", cellValues: " + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list(Belt_Array.map(param.cellValues, GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify))) + " }")));
}

var UpsertRow = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function t_encode$1(encoder_rowLocation, encoder_cellUpdate, v) {
  return Js_dict.fromArray([
              [
                "rowLocation",
                Curry._1(encoder_rowLocation, v.rowLocation)
              ],
              [
                "updatedColIndex",
                Decco.intToJson(v.updatedColIndex)
              ],
              [
                "cellUpdate",
                Curry._1(encoder_cellUpdate, v.cellUpdate)
              ]
            ]);
}

function t_decode$1(decoder_rowLocation, decoder_cellUpdate, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var rowLocation = Curry._1(decoder_rowLocation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowLocation"), null));
  if (rowLocation.TAG === /* Ok */0) {
    var updatedColIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updatedColIndex"), null));
    if (updatedColIndex.TAG === /* Ok */0) {
      var cellUpdate = Curry._1(decoder_cellUpdate, Belt_Option.getWithDefault(Js_dict.get(dict$1, "cellUpdate"), null));
      if (cellUpdate.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  rowLocation: rowLocation._0,
                  updatedColIndex: updatedColIndex._0,
                  cellUpdate: cellUpdate._0
                }
              };
      }
      var e = cellUpdate._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".cellUpdate" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = updatedColIndex._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".updatedColIndex" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = rowLocation._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".rowLocation" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify$1(stringifyRowLocation, stringifyCellUpdate, param) {
  return "{ rowLocation: " + (Curry._1(stringifyRowLocation, param.rowLocation) + ("], updatedColIndex: " + (String(param.updatedColIndex) + (", cellUpdate: " + (Curry._1(stringifyCellUpdate, param.cellUpdate) + " }")))));
}

var UpdateCell = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1
};

function t_encode$2(encoder_rowLocation, encoder_cellUpdate, v) {
  if (v.TAG === /* UpsertRow */0) {
    return [
            "UpsertRow",
            t_encode(encoder_rowLocation, v._0)
          ];
  } else {
    return [
            "UpdateCell",
            t_encode$1(encoder_rowLocation, encoder_cellUpdate, v._0)
          ];
  }
}

function t_decode$2(decoder_rowLocation, decoder_cellUpdate, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "UpdateCell" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$1(decoder_rowLocation, decoder_cellUpdate, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UpdateCell */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "UpsertRow" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode(decoder_rowLocation, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UpsertRow */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$2(stringifyRowLocation, stringifyCellUpdate, commandValue) {
  if (commandValue.TAG === /* UpsertRow */0) {
    return "UpsertRow(" + (stringify(stringifyRowLocation, commandValue._0) + ")");
  } else {
    return "UpdateCell(" + (stringify$1(stringifyRowLocation, stringifyCellUpdate, commandValue._0) + ")");
  }
}

function getRowLocation(update) {
  return update._0.rowLocation;
}

function actOnSameRow(update1, update2, getKeyColumnIndexFromRowLocation, getKeyColumnValueFromRowLocation) {
  var rowLocation1 = update1._0.rowLocation;
  var rowLocation2 = update2._0.rowLocation;
  if (Curry._1(getKeyColumnIndexFromRowLocation, rowLocation1) !== Curry._1(getKeyColumnIndexFromRowLocation, rowLocation2)) {
    return false;
  }
  var match = Curry._1(getKeyColumnValueFromRowLocation, rowLocation1);
  var match$1 = Curry._1(getKeyColumnValueFromRowLocation, rowLocation2);
  if (typeof match === "number" || !(match.TAG === /* Value */1 && !(typeof match$1 === "number" || match$1.TAG !== /* Value */1))) {
    return Caml_obj.caml_equal(match, match$1);
  } else {
    return Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, match._0) === Curry._1(DataDependency$SmartcutsMacros.DataRef.resolveAsText, match$1._0);
  }
}

function merge(lastCopyInfo, getNewValueFromCellUpdate, getKeyColumnIndexFromRowLocation, getKeyColumnValueFromRowLocation, intoUpdate, mapRowLocationData, update) {
  if (!actOnSameRow(intoUpdate, update, getKeyColumnIndexFromRowLocation, getKeyColumnValueFromRowLocation)) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Can't merge 2 updates that don't act on the same row");
  }
  if (intoUpdate.TAG === /* UpsertRow */0) {
    var match = intoUpdate._0;
    var cellValues = match.cellValues;
    if (update.TAG === /* UpsertRow */0) {
      return Util$SmartcutsMacros.logAndRaiseJsError("Unimplemented: Merge 2 UpsertRows");
    }
    var match$1 = update._0;
    var func = function (param, param$1, param$2) {
      return ArrayUtils$SmartcutsMacros.setAtIndexAndFillGap(match$1.updatedColIndex, param, param$1, param$2);
    };
    var param = Curry._2(GoogleSheetTypes$SmartcutsMacros.Cell.Value.adjustAnyPasteToReferenceLastCopyCommand, lastCopyInfo, Curry._1(getNewValueFromCellUpdate, match$1.cellUpdate));
    var func$1 = Curry._1(func, param);
    return {
            TAG: /* UpsertRow */0,
            _0: {
              rowLocation: Curry._2(mapRowLocationData, match.rowLocation, Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.adjustAnyPasteToReferenceLastCopyCommand, lastCopyInfo)),
              cellValues: Curry._1((function (param) {
                      return Curry._2(func$1, param, cellValues);
                    }), /* Empty */0)
            }
          };
  }
  var match$2 = intoUpdate._0;
  var updatedColIndex_1 = match$2.updatedColIndex;
  var rowLocation = match$2.rowLocation;
  if (update.TAG === /* UpsertRow */0) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Unimplemented: Merge UpdateCell followed by UpsertRow");
  }
  var match$3 = update._0;
  var updatedColIndex_2 = match$3.updatedColIndex;
  return {
          TAG: /* UpsertRow */0,
          _0: {
            rowLocation: rowLocation,
            cellValues: ArrayUtils$SmartcutsMacros.setWithoutFill(updatedColIndex_2, Curry._1(getNewValueFromCellUpdate, match$3.cellUpdate), ArrayUtils$SmartcutsMacros.setWithoutFill(updatedColIndex_1, Curry._1(getNewValueFromCellUpdate, match$2.cellUpdate), ArrayUtils$SmartcutsMacros.setWithoutFill(Curry._1(getKeyColumnIndexFromRowLocation, rowLocation), Curry._1(getKeyColumnValueFromRowLocation, rowLocation), Caml_array.make((
                              updatedColIndex_1 > updatedColIndex_2 ? updatedColIndex_1 : updatedColIndex_2
                            ) + 1 | 0, /* Unknown */1))))
          }
        };
}

var Update = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$2,
  getRowLocation: getRowLocation,
  actOnSameRow: actOnSameRow,
  merge: merge
};

function t_encode$3(encoder_rowLocation, encoder_cellUpdate, v) {
  return Js_dict.fromArray([
              [
                "spreadsheetId",
                Decco.stringToJson(v.spreadsheetId)
              ],
              [
                "sheetName",
                Decco.stringToJson(v.sheetName)
              ],
              [
                "colNames",
                Decco.arrayToJson(Decco.stringToJson, v.colNames)
              ],
              [
                "update",
                t_encode$2(encoder_rowLocation, encoder_cellUpdate, v.update)
              ]
            ]);
}

function t_decode$3(decoder_rowLocation, decoder_cellUpdate, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
  if (spreadsheetId.TAG === /* Ok */0) {
    var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
    if (sheetName.TAG === /* Ok */0) {
      var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
      if (colNames.TAG === /* Ok */0) {
        var update = t_decode$2(decoder_rowLocation, decoder_cellUpdate, Belt_Option.getWithDefault(Js_dict.get(dict$1, "update"), null));
        if (update.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    spreadsheetId: spreadsheetId._0,
                    sheetName: sheetName._0,
                    colNames: colNames._0,
                    update: update._0
                  }
                };
        }
        var e = update._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".update" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = colNames._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".colNames" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = sheetName._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sheetName" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = spreadsheetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".spreadsheetId" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function stringify$3(stringifyRowLocation, stringifyCellUpdate, param) {
  return "{ spreadsheetId: " + (param.spreadsheetId + (", sheetName: " + (param.sheetName + (", colNames: [" + (param.colNames.join(", ") + ("], update: " + (stringify$2(stringifyRowLocation, stringifyCellUpdate, param.update) + " }")))))));
}

var Generic = {
  UpsertRow: UpsertRow,
  UpdateCell: UpdateCell,
  Update: Update,
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  stringify: stringify$3
};

function t_encode$4(v) {
  return Js_dict.fromArray([
              [
                "spreadsheetId",
                Decco.stringToJson(v.spreadsheetId)
              ],
              [
                "sheetName",
                Decco.stringToJson(v.sheetName)
              ],
              [
                "colNames",
                Decco.arrayToJson(Decco.stringToJson, v.colNames)
              ],
              [
                "sheetDiff",
                GoogleSheetTypes$SmartcutsMacros.SheetDiff.t_encode(v.sheetDiff)
              ]
            ]);
}

function t_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
  if (spreadsheetId.TAG === /* Ok */0) {
    var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
    if (sheetName.TAG === /* Ok */0) {
      var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
      if (colNames.TAG === /* Ok */0) {
        var sheetDiff = GoogleSheetTypes$SmartcutsMacros.SheetDiff.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetDiff"), null));
        if (sheetDiff.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    spreadsheetId: spreadsheetId._0,
                    sheetName: sheetName._0,
                    colNames: colNames._0,
                    sheetDiff: sheetDiff._0
                  }
                };
        }
        var e = sheetDiff._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".sheetDiff" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = colNames._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".colNames" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = sheetName._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sheetName" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = spreadsheetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".spreadsheetId" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function stringify$4(param) {
  return "{ spreadsheetId: " + (param.spreadsheetId + (", sheetName: " + (param.sheetName + (", colNames: [" + (param.colNames.join(", ") + (", sheetDiff: " + (GoogleSheetTypes$SmartcutsMacros.SheetDiff.stringify(param.sheetDiff) + ")")))))));
}

var Recording = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  stringify: stringify$4
};

function t_encode$5(v) {
  return Js_dict.fromArray([
              [
                "fromValue",
                Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.fromValue)
              ],
              [
                "toValue",
                Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.toValue)
              ]
            ]);
}

function t_decode$5(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var fromValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fromValue"), null));
  if (fromValue.TAG === /* Ok */0) {
    var toValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "toValue"), null));
    if (toValue.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                fromValue: fromValue._0,
                toValue: toValue._0
              }
            };
    }
    var e = toValue._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".toValue" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = fromValue._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".fromValue" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$5(param) {
  return "{ fromValue: " + (Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify, param.fromValue) + (", toValue: " + (Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify, param.toValue) + " }")));
}

function fromCellContentDiff(diff) {
  switch (diff.TAG | 0) {
    case /* FromTo */0 :
        var match = diff._0;
        return {
                fromValue: match.from,
                toValue: match.to_
              };
    case /* Added */1 :
        return {
                fromValue: /* Empty */0,
                toValue: diff._0
              };
    case /* Removed */2 :
        return {
                fromValue: diff._0,
                toValue: /* Empty */0
              };
    
  }
}

function mapDataRef(f, param) {
  var func = GoogleSheetTypes$SmartcutsMacros.Cell.Value.mapDataRef;
  var func$1 = GoogleSheetTypes$SmartcutsMacros.Cell.Value.mapDataRef;
  return {
          fromValue: Curry._2(func, f, param.fromValue),
          toValue: Curry._2(func$1, f, param.toValue)
        };
}

var CellUpdate = {
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  stringify: stringify$5,
  fromCellContentDiff: fromCellContentDiff,
  mapDataRef: mapDataRef
};

function t_encode$6(v) {
  return Js_dict.fromArray([
              [
                "rowIndex",
                Decco.intToJson(v.rowIndex)
              ],
              [
                "keyColumnIndex",
                Decco.intToJson(v.keyColumnIndex)
              ],
              [
                "rowData",
                Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.rowData)
              ]
            ]);
}

function t_decode$6(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var rowIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowIndex"), null));
  if (rowIndex.TAG === /* Ok */0) {
    var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
    if (keyColumnIndex.TAG === /* Ok */0) {
      var rowData = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowData"), null));
      if (rowData.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  rowIndex: rowIndex._0,
                  keyColumnIndex: keyColumnIndex._0,
                  rowData: rowData._0
                }
              };
      }
      var e = rowData._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".rowData" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = keyColumnIndex._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".keyColumnIndex" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = rowIndex._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".rowIndex" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify$6(param) {
  return "{ rowIndex: " + (String(param.rowIndex) + (", keyColumnIndex: " + (String(param.keyColumnIndex) + (", rowData: [" + (param.rowData.join(", ") + "]}")))));
}

function getPrimaryKeyText(param) {
  return Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringGet, Belt_Array.getExn(param.rowData, param.keyColumnIndex));
}

var RowLocation = {
  t_encode: t_encode$6,
  t_decode: t_decode$6,
  stringify: stringify$6,
  getPrimaryKeyText: getPrimaryKeyText
};

function t_encode$7(v) {
  return t_encode$3(t_encode$6, t_encode$5, v);
}

function t_decode$7(v) {
  return t_decode$3(t_decode$6, t_decode$5, v);
}

function stringify$7(commandValue) {
  return stringify$3(stringify$6, stringify$5, commandValue);
}

function getIdentifier(param) {
  var update = param.update;
  var match;
  if (update.TAG === /* UpsertRow */0) {
    var match$1 = update._0;
    var firstUpdatedColIndex = OptionUtils$SmartcutsMacros.withDefault(0, Belt_Array.getIndexBy(match$1.cellValues, (function (param) {
                return Util$SmartcutsMacros.compose(Util$SmartcutsMacros.not_, GoogleSheetTypes$SmartcutsMacros.Cell.Value.isEmpty, param);
              })));
    match = [
      match$1.rowLocation.rowIndex,
      firstUpdatedColIndex
    ];
  } else {
    var match$2 = update._0;
    match = [
      match$2.rowLocation.rowIndex,
      match$2.updatedColIndex
    ];
  }
  return param.sheetName + ("!" + fromRowColStarting0(match[0], match[1]));
}

function fromRecordingCommandValue(param) {
  var sheetDiff = param.sheetDiff;
  var colNames = param.colNames;
  var sheetName = param.sheetName;
  var spreadsheetId = param.spreadsheetId;
  switch (sheetDiff.TAG | 0) {
    case /* UpdateCell */0 :
        var match = sheetDiff._1;
        var priorCells = match.cells;
        var rowIndex = match.rowIndex;
        var match$1 = sheetDiff._0;
        var diff = match$1.diff;
        var colIndex = match$1.colIndex;
        var tmp;
        if (Belt_Array.every(priorCells, GoogleSheetTypes$SmartcutsMacros.Cell.Value.isEmpty)) {
          var allPriorCells = GoogleSheetHelpers$SmartcutsMacros.maybePadMissingCellsWithEmptyValues(colIndex, priorCells);
          var updatedCells = ArrayUtils$SmartcutsMacros.replaceAtIndex(allPriorCells, colIndex, Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.CellDiff.ContentDiff.rhs, diff));
          tmp = {
            TAG: /* UpsertRow */0,
            _0: {
              rowLocation: {
                rowIndex: rowIndex,
                keyColumnIndex: colIndex,
                rowData: updatedCells
              },
              cellValues: updatedCells
            }
          };
        } else {
          var arg = ArrayUtils$SmartcutsMacros.shortcutWithIndex((function (cellValue, index) {
                  if (!Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.isEmpty, cellValue) && colIndex !== index) {
                    return index;
                  }
                  
                }), priorCells);
          tmp = {
            TAG: /* UpdateCell */1,
            _0: {
              rowLocation: {
                rowIndex: rowIndex,
                keyColumnIndex: (function (param) {
                      return OptionUtils$SmartcutsMacros.getExn(param, arg);
                    })("Expected to find a non-empty key col index != updated col index"),
                rowData: priorCells
              },
              updatedColIndex: colIndex,
              cellUpdate: fromCellContentDiff(diff)
            }
          };
        }
        return {
                spreadsheetId: spreadsheetId,
                sheetName: sheetName,
                colNames: colNames,
                update: tmp
              };
    case /* AppendRow */1 :
        var match$2 = sheetDiff._0;
        var cells = match$2.cells;
        var arg$1 = Belt_Array.getIndexBy(cells, (function (param) {
                return Util$SmartcutsMacros.compose(Util$SmartcutsMacros.not_, GoogleSheetTypes$SmartcutsMacros.Cell.Value.isEmpty, param);
              }));
        return {
                spreadsheetId: spreadsheetId,
                sheetName: sheetName,
                colNames: colNames,
                update: {
                  TAG: /* UpsertRow */0,
                  _0: {
                    rowLocation: {
                      rowIndex: match$2.rowIndex,
                      keyColumnIndex: (function (param) {
                            return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                          })("A new row must not be composed of all empty cells"),
                      rowData: cells
                    },
                    cellValues: cells
                  }
                }
              };
    case /* DeleteRow */2 :
        return Util$SmartcutsMacros.logAndRaiseJsError("Unimplemented: DeleteRow(*)");
    
  }
}

var Authoring = {
  CellUpdate: CellUpdate,
  RowLocation: RowLocation,
  t_encode: t_encode$7,
  t_decode: t_decode$7,
  stringify: stringify$7,
  getIdentifier: getIdentifier,
  fromRecordingCommandValue: fromRecordingCommandValue
};

function t_encode$8(v) {
  return Js_dict.fromArray([
              [
                "keyColumnIndex",
                Decco.intToJson(v.keyColumnIndex)
              ],
              [
                "keyColumnValue",
                Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.keyColumnValue)
              ]
            ]);
}

function t_decode$8(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
  if (keyColumnIndex.TAG === /* Ok */0) {
    var keyColumnValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnValue"), null));
    if (keyColumnValue.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                keyColumnIndex: keyColumnIndex._0,
                keyColumnValue: keyColumnValue._0
              }
            };
    }
    var e = keyColumnValue._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".keyColumnValue" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = keyColumnIndex._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".keyColumnIndex" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$8(param) {
  return "{ keyColumnIndex: " + (String(param.keyColumnIndex) + (", keyColumnValue: " + (Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify, param.keyColumnValue) + " }")));
}

function getPrimaryKeyText$1(param) {
  return Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringGet, param.keyColumnValue);
}

function maybeGetCommandIdPointedToByMaybePrimaryKeyRef(param) {
  var keyColumnValue = param.keyColumnValue;
  if (typeof keyColumnValue === "number") {
    return ;
  }
  if (keyColumnValue.TAG !== /* Value */1) {
    return ;
  }
  var match = keyColumnValue._0;
  if (match.TAG === /* TextFromGSheetUpsertCommand */3) {
    return match._0.commandId;
  }
  
}

var RowLocation$1 = {
  t_encode: t_encode$8,
  t_decode: t_decode$8,
  stringify: stringify$8,
  getPrimaryKeyText: getPrimaryKeyText$1,
  maybeGetCommandIdPointedToByMaybePrimaryKeyRef: maybeGetCommandIdPointedToByMaybePrimaryKeyRef
};

function t_encode$9(v) {
  return t_encode$3(t_encode$8, GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v);
}

function t_decode$9(v) {
  return t_decode$3(t_decode$8, GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, v);
}

function stringify$9(commandValue) {
  return stringify$3(stringify$8, GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify, commandValue);
}

function fromAuthoringCommandValue(authoringCommandValue) {
  var update = authoringCommandValue.update;
  if (update.TAG === /* UpsertRow */0) {
    var match = update._0;
    var match$1 = match.rowLocation;
    var keyColumnIndex = match$1.keyColumnIndex;
    return {
            spreadsheetId: authoringCommandValue.spreadsheetId,
            sheetName: authoringCommandValue.sheetName,
            colNames: authoringCommandValue.colNames,
            update: {
              TAG: /* UpsertRow */0,
              _0: {
                rowLocation: {
                  keyColumnIndex: keyColumnIndex,
                  keyColumnValue: Caml_array.get(match$1.rowData, keyColumnIndex)
                },
                cellValues: match.cellValues
              }
            }
          };
  }
  var match$2 = update._0;
  var match$3 = match$2.rowLocation;
  var keyColumnIndex$1 = match$3.keyColumnIndex;
  return {
          spreadsheetId: authoringCommandValue.spreadsheetId,
          sheetName: authoringCommandValue.sheetName,
          colNames: authoringCommandValue.colNames,
          update: {
            TAG: /* UpdateCell */1,
            _0: {
              rowLocation: {
                keyColumnIndex: keyColumnIndex$1,
                keyColumnValue: Caml_array.get(match$3.rowData, keyColumnIndex$1)
              },
              updatedColIndex: match$2.updatedColIndex,
              cellUpdate: match$2.cellUpdate.toValue
            }
          }
        };
}

var Playback = {
  RowLocation: RowLocation$1,
  t_encode: t_encode$9,
  t_decode: t_decode$9,
  stringify: stringify$9,
  fromAuthoringCommandValue: fromAuthoringCommandValue
};

var CommandValue = {
  Generic: Generic,
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback
};

function t_encode$10(v) {
  return Js_dict.fromArray([
              [
                "spreadsheetId",
                Decco.stringToJson(v.spreadsheetId)
              ],
              [
                "sheetName",
                Decco.stringToJson(v.sheetName)
              ],
              [
                "colNames",
                Decco.arrayToJson(Decco.stringToJson, v.colNames)
              ],
              [
                "rowData",
                Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.rowData)
              ],
              [
                "keyColumnIndex",
                Decco.intToJson(v.keyColumnIndex)
              ],
              [
                "keyColumnValue",
                Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.keyColumnValue)
              ],
              [
                "cellUpdate",
                t_encode$5(v.cellUpdate)
              ],
              [
                "updatedColIndex",
                Decco.intToJson(v.updatedColIndex)
              ],
              [
                "dynamic",
                Decco.boolToJson(v.dynamic)
              ],
              [
                "playbackFormLabel",
                Decco.stringToJson(v.playbackFormLabel)
              ]
            ]);
}

function t_decode$10(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
  if (spreadsheetId.TAG === /* Ok */0) {
    var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
    if (sheetName.TAG === /* Ok */0) {
      var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
      if (colNames.TAG === /* Ok */0) {
        var rowData = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowData"), null));
        if (rowData.TAG === /* Ok */0) {
          var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
          if (keyColumnIndex.TAG === /* Ok */0) {
            var keyColumnValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnValue"), null));
            if (keyColumnValue.TAG === /* Ok */0) {
              var cellUpdate = t_decode$5(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cellUpdate"), null));
              if (cellUpdate.TAG === /* Ok */0) {
                var updatedColIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updatedColIndex"), null));
                if (updatedColIndex.TAG === /* Ok */0) {
                  var dynamic = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dynamic"), null));
                  if (dynamic.TAG === /* Ok */0) {
                    var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
                    if (playbackFormLabel.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: {
                                spreadsheetId: spreadsheetId._0,
                                sheetName: sheetName._0,
                                colNames: colNames._0,
                                rowData: rowData._0,
                                keyColumnIndex: keyColumnIndex._0,
                                keyColumnValue: keyColumnValue._0,
                                cellUpdate: cellUpdate._0,
                                updatedColIndex: updatedColIndex._0,
                                dynamic: dynamic._0,
                                playbackFormLabel: playbackFormLabel._0
                              }
                            };
                    }
                    var e = playbackFormLabel._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".playbackFormLabel" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = dynamic._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".dynamic" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }
                var e$2 = updatedColIndex._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".updatedColIndex" + e$2.path,
                          message: e$2.message,
                          value: e$2.value
                        }
                      };
              }
              var e$3 = cellUpdate._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".cellUpdate" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                      }
                    };
            }
            var e$4 = keyColumnValue._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".keyColumnValue" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = keyColumnIndex._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".keyColumnIndex" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
        }
        var e$6 = rowData._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".rowData" + e$6.path,
                  message: e$6.message,
                  value: e$6.value
                }
              };
      }
      var e$7 = colNames._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".colNames" + e$7.path,
                message: e$7.message,
                value: e$7.value
              }
            };
    }
    var e$8 = sheetName._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sheetName" + e$8.path,
              message: e$8.message,
              value: e$8.value
            }
          };
  }
  var e$9 = spreadsheetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".spreadsheetId" + e$9.path,
            message: e$9.message,
            value: e$9.value
          }
        };
}

function generatePlaybackFormLabel(param, param$1, colNames, updatedColIndex) {
  return "Value for " + Caml_array.get(colNames, updatedColIndex);
}

function updateKeyColumnIndex(keyColumnIndex, config) {
  return {
          spreadsheetId: config.spreadsheetId,
          sheetName: config.sheetName,
          colNames: config.colNames,
          rowData: config.rowData,
          keyColumnIndex: keyColumnIndex,
          keyColumnValue: config.keyColumnValue,
          cellUpdate: config.cellUpdate,
          updatedColIndex: config.updatedColIndex,
          dynamic: config.dynamic,
          playbackFormLabel: generatePlaybackFormLabel(keyColumnIndex, config.rowData, config.colNames, config.updatedColIndex)
        };
}

var UpdateCellConfig = {
  t_encode: t_encode$10,
  t_decode: t_decode$10,
  generatePlaybackFormLabel: generatePlaybackFormLabel,
  updateKeyColumnIndex: updateKeyColumnIndex
};

function t_encode$11(v) {
  return Js_dict.fromArray([
              [
                "spreadsheetId",
                Decco.stringToJson(v.spreadsheetId)
              ],
              [
                "sheetName",
                Decco.stringToJson(v.sheetName)
              ],
              [
                "colNames",
                Decco.arrayToJson(Decco.stringToJson, v.colNames)
              ],
              [
                "rowData",
                Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.rowData)
              ],
              [
                "keyColumnIndex",
                Decco.intToJson(v.keyColumnIndex)
              ],
              [
                "keyColumnValue",
                Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.keyColumnValue)
              ],
              [
                "dynamic",
                Decco.boolToJson(v.dynamic)
              ],
              [
                "playbackFormLabel",
                Decco.stringToJson(v.playbackFormLabel)
              ]
            ]);
}

function t_decode$11(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
  if (spreadsheetId.TAG === /* Ok */0) {
    var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
    if (sheetName.TAG === /* Ok */0) {
      var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
      if (colNames.TAG === /* Ok */0) {
        var rowData = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowData"), null));
        if (rowData.TAG === /* Ok */0) {
          var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
          if (keyColumnIndex.TAG === /* Ok */0) {
            var keyColumnValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnValue"), null));
            if (keyColumnValue.TAG === /* Ok */0) {
              var dynamic = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dynamic"), null));
              if (dynamic.TAG === /* Ok */0) {
                var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
                if (playbackFormLabel.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            spreadsheetId: spreadsheetId._0,
                            sheetName: sheetName._0,
                            colNames: colNames._0,
                            rowData: rowData._0,
                            keyColumnIndex: keyColumnIndex._0,
                            keyColumnValue: keyColumnValue._0,
                            dynamic: dynamic._0,
                            playbackFormLabel: playbackFormLabel._0
                          }
                        };
                }
                var e = playbackFormLabel._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".playbackFormLabel" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = dynamic._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".dynamic" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = keyColumnValue._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".keyColumnValue" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = keyColumnIndex._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".keyColumnIndex" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = rowData._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".rowData" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = colNames._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".colNames" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = sheetName._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sheetName" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = spreadsheetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".spreadsheetId" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function generatePlaybackFormLabel$1(keyColumnIndex, param, colNames) {
  return Caml_array.get(colNames, keyColumnIndex);
}

function updateKeyColumnIndex$1(keyColumnIndex, config) {
  return {
          spreadsheetId: config.spreadsheetId,
          sheetName: config.sheetName,
          colNames: config.colNames,
          rowData: config.rowData,
          keyColumnIndex: keyColumnIndex,
          keyColumnValue: config.keyColumnValue,
          dynamic: config.dynamic,
          playbackFormLabel: Caml_array.get(config.colNames, keyColumnIndex)
        };
}

var UpsertRowConfig = {
  t_encode: t_encode$11,
  t_decode: t_decode$11,
  generatePlaybackFormLabel: generatePlaybackFormLabel$1,
  updateKeyColumnIndex: updateKeyColumnIndex$1
};

function t_encode$12(v) {
  if (v.TAG === /* UpdateCellConfig */0) {
    return [
            "UpdateCellConfig",
            t_encode$10(v._0)
          ];
  } else {
    return [
            "UpsertRowConfig",
            t_encode$11(v._0)
          ];
  }
}

function t_decode$12(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "UpdateCellConfig" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$10(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UpdateCellConfig */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "UpsertRowConfig" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode$11(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UpsertRowConfig */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function generatePlaybackFormLabelFromAuthoringCommandValue(param) {
  var update = param.update;
  var colNames = param.colNames;
  if (update.TAG === /* UpsertRow */0) {
    return Caml_array.get(colNames, 0);
  } else {
    return Caml_array.get(colNames, update._0.updatedColIndex);
  }
}

function fromAuthoringCommandValue$1(authoringCommandValue) {
  var update = authoringCommandValue.update;
  var colNames = authoringCommandValue.colNames;
  var sheetName = authoringCommandValue.sheetName;
  var spreadsheetId = authoringCommandValue.spreadsheetId;
  if (update.TAG === /* UpsertRow */0) {
    var match = update._0;
    return {
            TAG: /* UpsertRowConfig */1,
            _0: {
              spreadsheetId: spreadsheetId,
              sheetName: sheetName,
              colNames: colNames,
              rowData: match.cellValues,
              keyColumnIndex: 0,
              keyColumnValue: Caml_array.get(match.rowLocation.rowData, 0),
              dynamic: false,
              playbackFormLabel: generatePlaybackFormLabelFromAuthoringCommandValue(authoringCommandValue)
            }
          };
  }
  var match$1 = update._0;
  var priorCells = match$1.rowLocation.rowData;
  return {
          TAG: /* UpdateCellConfig */0,
          _0: {
            spreadsheetId: spreadsheetId,
            sheetName: sheetName,
            colNames: colNames,
            rowData: priorCells,
            keyColumnIndex: 0,
            keyColumnValue: Caml_array.get(priorCells, 0),
            cellUpdate: match$1.cellUpdate,
            updatedColIndex: match$1.updatedColIndex,
            dynamic: false,
            playbackFormLabel: generatePlaybackFormLabelFromAuthoringCommandValue(authoringCommandValue)
          }
        };
}

function updateConfigWithPlaybackFormLabel(playbackFormLabel, config) {
  if (config.TAG === /* UpdateCellConfig */0) {
    var updateCellConfig = config._0;
    return {
            TAG: /* UpdateCellConfig */0,
            _0: {
              spreadsheetId: updateCellConfig.spreadsheetId,
              sheetName: updateCellConfig.sheetName,
              colNames: updateCellConfig.colNames,
              rowData: updateCellConfig.rowData,
              keyColumnIndex: updateCellConfig.keyColumnIndex,
              keyColumnValue: updateCellConfig.keyColumnValue,
              cellUpdate: updateCellConfig.cellUpdate,
              updatedColIndex: updateCellConfig.updatedColIndex,
              dynamic: updateCellConfig.dynamic,
              playbackFormLabel: playbackFormLabel
            }
          };
  }
  var upsertRowConfig = config._0;
  return {
          TAG: /* UpsertRowConfig */1,
          _0: {
            spreadsheetId: upsertRowConfig.spreadsheetId,
            sheetName: upsertRowConfig.sheetName,
            colNames: upsertRowConfig.colNames,
            rowData: upsertRowConfig.rowData,
            keyColumnIndex: upsertRowConfig.keyColumnIndex,
            keyColumnValue: upsertRowConfig.keyColumnValue,
            dynamic: upsertRowConfig.dynamic,
            playbackFormLabel: playbackFormLabel
          }
        };
}

function updateKeyColumnIndex$2(keyColumnIndex, config) {
  if (config.TAG === /* UpdateCellConfig */0) {
    return {
            TAG: /* UpdateCellConfig */0,
            _0: updateKeyColumnIndex(keyColumnIndex, config._0)
          };
  } else {
    return {
            TAG: /* UpsertRowConfig */1,
            _0: updateKeyColumnIndex$1(keyColumnIndex, config._0)
          };
  }
}

function isDynamic(config) {
  if (config.TAG === /* UpdateCellConfig */0) {
    return config._0.dynamic;
  } else {
    return config._0.dynamic;
  }
}

function updateConfigWithAuthoringCommandValue(param, config) {
  var update = param.update;
  var sheetName = param.sheetName;
  var spreadsheetId = param.spreadsheetId;
  if (update.TAG === /* UpsertRow */0) {
    if (config.TAG === /* UpdateCellConfig */0) {
      return Util$SmartcutsMacros.logAndRaiseJsError("Google Sheet update and config mismatch");
    }
    var config$1 = config._0;
    return {
            TAG: /* UpsertRowConfig */1,
            _0: {
              spreadsheetId: spreadsheetId,
              sheetName: sheetName,
              colNames: config$1.colNames,
              rowData: update._0.cellValues,
              keyColumnIndex: config$1.keyColumnIndex,
              keyColumnValue: config$1.keyColumnValue,
              dynamic: config$1.dynamic,
              playbackFormLabel: config$1.playbackFormLabel
            }
          };
  }
  if (config.TAG !== /* UpdateCellConfig */0) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Google Sheet update and config mismatch");
  }
  var config$2 = config._0;
  return {
          TAG: /* UpdateCellConfig */0,
          _0: {
            spreadsheetId: spreadsheetId,
            sheetName: sheetName,
            colNames: config$2.colNames,
            rowData: config$2.rowData,
            keyColumnIndex: config$2.keyColumnIndex,
            keyColumnValue: config$2.keyColumnValue,
            cellUpdate: update._0.cellUpdate,
            updatedColIndex: config$2.updatedColIndex,
            dynamic: config$2.dynamic,
            playbackFormLabel: config$2.playbackFormLabel
          }
        };
}

function isMergeable(config) {
  return false;
}

function mapDataRef$1(f, v) {
  if (v.TAG === /* UpdateCellConfig */0) {
    var updateCellConfig = v._0;
    var func = GoogleSheetTypes$SmartcutsMacros.Cell.Value.mapDataRef;
    return {
            TAG: /* UpdateCellConfig */0,
            _0: {
              spreadsheetId: updateCellConfig.spreadsheetId,
              sheetName: updateCellConfig.sheetName,
              colNames: updateCellConfig.colNames,
              rowData: Belt_Array.map(updateCellConfig.rowData, Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.mapDataRef, f)),
              keyColumnIndex: updateCellConfig.keyColumnIndex,
              keyColumnValue: Curry._2(func, f, updateCellConfig.keyColumnValue),
              cellUpdate: mapDataRef(f, updateCellConfig.cellUpdate),
              updatedColIndex: updateCellConfig.updatedColIndex,
              dynamic: updateCellConfig.dynamic,
              playbackFormLabel: updateCellConfig.playbackFormLabel
            }
          };
  }
  var upsertRowConfig = v._0;
  var func$1 = GoogleSheetTypes$SmartcutsMacros.Cell.Value.mapDataRef;
  return {
          TAG: /* UpsertRowConfig */1,
          _0: {
            spreadsheetId: upsertRowConfig.spreadsheetId,
            sheetName: upsertRowConfig.sheetName,
            colNames: upsertRowConfig.colNames,
            rowData: Belt_Array.map(upsertRowConfig.rowData, Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.mapDataRef, f)),
            keyColumnIndex: upsertRowConfig.keyColumnIndex,
            keyColumnValue: Curry._2(func$1, f, upsertRowConfig.keyColumnValue),
            dynamic: upsertRowConfig.dynamic,
            playbackFormLabel: upsertRowConfig.playbackFormLabel
          }
        };
}

var AuthoringConfig = {
  UpdateCellConfig: UpdateCellConfig,
  UpsertRowConfig: UpsertRowConfig,
  t_encode: t_encode$12,
  t_decode: t_decode$12,
  generatePlaybackFormLabelFromAuthoringCommandValue: generatePlaybackFormLabelFromAuthoringCommandValue,
  fromAuthoringCommandValue: fromAuthoringCommandValue$1,
  updateConfigWithPlaybackFormLabel: updateConfigWithPlaybackFormLabel,
  updateKeyColumnIndex: updateKeyColumnIndex$2,
  isDynamic: isDynamic,
  updateConfigWithAuthoringCommandValue: updateConfigWithAuthoringCommandValue,
  isMergeable: isMergeable,
  mapDataRef: mapDataRef$1
};

function t_encode$13(v) {
  return Js_dict.fromArray([
              [
                "spreadsheetId",
                Decco.stringToJson(v.spreadsheetId)
              ],
              [
                "sheetName",
                Decco.stringToJson(v.sheetName)
              ],
              [
                "colNames",
                Decco.arrayToJson(Decco.stringToJson, v.colNames)
              ],
              [
                "keyColumnIndex",
                Decco.intToJson(v.keyColumnIndex)
              ],
              [
                "keyColumnValue",
                Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.keyColumnValue)
              ],
              [
                "rowData",
                Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.rowData)
              ],
              [
                "playbackFormLabel",
                Decco.stringToJson(v.playbackFormLabel)
              ]
            ]);
}

function t_decode$13(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
  if (spreadsheetId.TAG === /* Ok */0) {
    var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
    if (sheetName.TAG === /* Ok */0) {
      var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
      if (colNames.TAG === /* Ok */0) {
        var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
        if (keyColumnIndex.TAG === /* Ok */0) {
          var keyColumnValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnValue"), null));
          if (keyColumnValue.TAG === /* Ok */0) {
            var rowData = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowData"), null));
            if (rowData.TAG === /* Ok */0) {
              var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
              if (playbackFormLabel.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          spreadsheetId: spreadsheetId._0,
                          sheetName: sheetName._0,
                          colNames: colNames._0,
                          keyColumnIndex: keyColumnIndex._0,
                          keyColumnValue: keyColumnValue._0,
                          rowData: rowData._0,
                          playbackFormLabel: playbackFormLabel._0
                        }
                      };
              }
              var e = playbackFormLabel._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".playbackFormLabel" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = rowData._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".rowData" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = keyColumnValue._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".keyColumnValue" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = keyColumnIndex._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".keyColumnIndex" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = colNames._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".colNames" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = sheetName._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sheetName" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = spreadsheetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".spreadsheetId" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

var UpsertRowParam = {
  t_encode: t_encode$13,
  t_decode: t_decode$13
};

function t_encode$14(v) {
  return Js_dict.fromArray([
              [
                "spreadsheetId",
                Decco.stringToJson(v.spreadsheetId)
              ],
              [
                "sheetName",
                Decco.stringToJson(v.sheetName)
              ],
              [
                "colNames",
                Decco.arrayToJson(Decco.stringToJson, v.colNames)
              ],
              [
                "keyColumnIndex",
                Decco.intToJson(v.keyColumnIndex)
              ],
              [
                "keyColumnValue",
                Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.keyColumnValue)
              ],
              [
                "updatedColIndex",
                Decco.intToJson(v.updatedColIndex)
              ],
              [
                "cellUpdate",
                t_encode$5(v.cellUpdate)
              ],
              [
                "playbackFormLabel",
                Decco.stringToJson(v.playbackFormLabel)
              ]
            ]);
}

function t_decode$14(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
  if (spreadsheetId.TAG === /* Ok */0) {
    var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
    if (sheetName.TAG === /* Ok */0) {
      var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
      if (colNames.TAG === /* Ok */0) {
        var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
        if (keyColumnIndex.TAG === /* Ok */0) {
          var keyColumnValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnValue"), null));
          if (keyColumnValue.TAG === /* Ok */0) {
            var updatedColIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updatedColIndex"), null));
            if (updatedColIndex.TAG === /* Ok */0) {
              var cellUpdate = t_decode$5(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cellUpdate"), null));
              if (cellUpdate.TAG === /* Ok */0) {
                var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
                if (playbackFormLabel.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            spreadsheetId: spreadsheetId._0,
                            sheetName: sheetName._0,
                            colNames: colNames._0,
                            keyColumnIndex: keyColumnIndex._0,
                            keyColumnValue: keyColumnValue._0,
                            updatedColIndex: updatedColIndex._0,
                            cellUpdate: cellUpdate._0,
                            playbackFormLabel: playbackFormLabel._0
                          }
                        };
                }
                var e = playbackFormLabel._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".playbackFormLabel" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = cellUpdate._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".cellUpdate" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = updatedColIndex._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".updatedColIndex" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = keyColumnValue._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".keyColumnValue" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = keyColumnIndex._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".keyColumnIndex" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = colNames._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".colNames" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = sheetName._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sheetName" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = spreadsheetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".spreadsheetId" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

var UpdateCellParam = {
  t_encode: t_encode$14,
  t_decode: t_decode$14
};

function t_encode$15(v) {
  if (v.TAG === /* UpdateCellParam */0) {
    return [
            "UpdateCellParam",
            t_encode$14(v._0)
          ];
  } else {
    return [
            "UpsertRowParam",
            t_encode$13(v._0)
          ];
  }
}

function t_decode$15(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "UpdateCellParam" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$14(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UpdateCellParam */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "UpsertRowParam" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode$13(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UpsertRowParam */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function fromCommandValueConfigurability(config) {
  if (config.TAG === /* UpdateCellConfig */0) {
    var match = config._0;
    return {
            TAG: /* UpdateCellParam */0,
            _0: {
              spreadsheetId: match.spreadsheetId,
              sheetName: match.sheetName,
              colNames: match.colNames,
              keyColumnIndex: match.keyColumnIndex,
              keyColumnValue: match.keyColumnValue,
              updatedColIndex: match.updatedColIndex,
              cellUpdate: match.cellUpdate,
              playbackFormLabel: match.playbackFormLabel
            }
          };
  }
  var match$1 = config._0;
  return {
          TAG: /* UpsertRowParam */1,
          _0: {
            spreadsheetId: match$1.spreadsheetId,
            sheetName: match$1.sheetName,
            colNames: match$1.colNames,
            keyColumnIndex: match$1.keyColumnIndex,
            keyColumnValue: match$1.keyColumnValue,
            rowData: match$1.rowData,
            playbackFormLabel: match$1.playbackFormLabel
          }
        };
}

function getPlaybackFormLabelFromParam(config) {
  if (config.TAG === /* UpdateCellParam */0) {
    return config._0.playbackFormLabel;
  } else {
    return config._0.playbackFormLabel;
  }
}

var ParamDescriptor = {
  UpsertRowParam: UpsertRowParam,
  UpdateCellParam: UpdateCellParam,
  t_encode: t_encode$15,
  t_decode: t_decode$15,
  fromCommandValueConfigurability: fromCommandValueConfigurability,
  getPlaybackFormLabelFromParam: getPlaybackFormLabelFromParam
};

function t_encode$16(v) {
  return Js_dict.fromArray([
              [
                "spreadsheetId",
                Decco.stringToJson(v.spreadsheetId)
              ],
              [
                "sheetName",
                Decco.stringToJson(v.sheetName)
              ],
              [
                "keyColumnIndex",
                Decco.intToJson(v.keyColumnIndex)
              ],
              [
                "keyColumnValue",
                Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.keyColumnValue)
              ],
              [
                "colNames",
                Decco.arrayToJson(Decco.stringToJson, v.colNames)
              ],
              [
                "updatedColIndex",
                Decco.intToJson(v.updatedColIndex)
              ],
              [
                "cellUpdate",
                Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.cellUpdate)
              ]
            ]);
}

function t_decode$16(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
  if (spreadsheetId.TAG === /* Ok */0) {
    var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
    if (sheetName.TAG === /* Ok */0) {
      var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
      if (keyColumnIndex.TAG === /* Ok */0) {
        var keyColumnValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnValue"), null));
        if (keyColumnValue.TAG === /* Ok */0) {
          var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
          if (colNames.TAG === /* Ok */0) {
            var updatedColIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updatedColIndex"), null));
            if (updatedColIndex.TAG === /* Ok */0) {
              var cellUpdate = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "cellUpdate"), null));
              if (cellUpdate.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          spreadsheetId: spreadsheetId._0,
                          sheetName: sheetName._0,
                          keyColumnIndex: keyColumnIndex._0,
                          keyColumnValue: keyColumnValue._0,
                          colNames: colNames._0,
                          updatedColIndex: updatedColIndex._0,
                          cellUpdate: cellUpdate._0
                        }
                      };
              }
              var e = cellUpdate._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".cellUpdate" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = updatedColIndex._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".updatedColIndex" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = colNames._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".colNames" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = keyColumnValue._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".keyColumnValue" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = keyColumnIndex._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".keyColumnIndex" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = sheetName._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sheetName" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = spreadsheetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".spreadsheetId" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function stringify$10(param) {
  return "{ keyColumnValue: " + (Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify, param.keyColumnValue) + (", keyColumnIndex: " + (String(param.keyColumnIndex) + (", spreadsheetId: " + (param.spreadsheetId + (", sheetName: " + (param.sheetName + (", cellUpdate: " + (Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify, param.cellUpdate) + "] }")))))))));
}

var UpdateCellParamValue = {
  t_encode: t_encode$16,
  t_decode: t_decode$16,
  stringify: stringify$10
};

function t_encode$17(v) {
  return Js_dict.fromArray([
              [
                "spreadsheetId",
                Decco.stringToJson(v.spreadsheetId)
              ],
              [
                "sheetName",
                Decco.stringToJson(v.sheetName)
              ],
              [
                "keyColumnIndex",
                Decco.intToJson(v.keyColumnIndex)
              ],
              [
                "keyColumnValue",
                Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.keyColumnValue)
              ],
              [
                "colNames",
                Decco.arrayToJson(Decco.stringToJson, v.colNames)
              ],
              [
                "rowData",
                Decco.arrayToJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_encode, v.rowData)
              ]
            ]);
}

function t_decode$17(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
  if (spreadsheetId.TAG === /* Ok */0) {
    var sheetName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheetName"), null));
    if (sheetName.TAG === /* Ok */0) {
      var keyColumnIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnIndex"), null));
      if (keyColumnIndex.TAG === /* Ok */0) {
        var keyColumnValue = Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "keyColumnValue"), null));
        if (keyColumnValue.TAG === /* Ok */0) {
          var colNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "colNames"), null));
          if (colNames.TAG === /* Ok */0) {
            var rowData = Decco.arrayFromJson(GoogleSheetTypes$SmartcutsMacros.Cell.Value.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rowData"), null));
            if (rowData.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        spreadsheetId: spreadsheetId._0,
                        sheetName: sheetName._0,
                        keyColumnIndex: keyColumnIndex._0,
                        keyColumnValue: keyColumnValue._0,
                        colNames: colNames._0,
                        rowData: rowData._0
                      }
                    };
            }
            var e = rowData._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".rowData" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = colNames._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".colNames" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = keyColumnValue._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".keyColumnValue" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = keyColumnIndex._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".keyColumnIndex" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = sheetName._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sheetName" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = spreadsheetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".spreadsheetId" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function stringify$11(param) {
  return "{ keyColumnValue: " + (Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify, param.keyColumnValue) + (", keyColumnIndex: " + (String(param.keyColumnIndex) + (", spreadsheetId: " + (param.spreadsheetId + (", sheetName: " + (param.sheetName + (", cellUpdate: " + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list(Belt_Array.map(param.rowData, GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringify))) + "] }")))))))));
}

var UpsertRowParamValue = {
  t_encode: t_encode$17,
  t_decode: t_decode$17,
  stringify: stringify$11
};

function t_encode$18(v) {
  if (v.TAG === /* UpdateCellParamValue */0) {
    return [
            "UpdateCellParamValue",
            t_encode$16(v._0)
          ];
  } else {
    return [
            "UpsertRowParamValue",
            t_encode$17(v._0)
          ];
  }
}

function t_decode$18(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "UpdateCellParamValue" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$16(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UpdateCellParamValue */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "UpsertRowParamValue" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode$17(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UpsertRowParamValue */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$12(v) {
  if (v.TAG === /* UpdateCellParamValue */0) {
    return "UpdateCellParamValue(" + (stringify$10(v._0) + ")");
  } else {
    return "UpsertRowParamValue(" + (stringify$11(v._0) + ")");
  }
}

function fromParamDescriptor(param) {
  if (param.TAG === /* UpdateCellParam */0) {
    var match = param._0;
    return {
            TAG: /* UpdateCellParamValue */0,
            _0: {
              spreadsheetId: match.spreadsheetId,
              sheetName: match.sheetName,
              keyColumnIndex: match.keyColumnIndex,
              keyColumnValue: match.keyColumnValue,
              colNames: match.colNames,
              updatedColIndex: match.updatedColIndex,
              cellUpdate: match.cellUpdate.toValue
            }
          };
  }
  var match$1 = param._0;
  return {
          TAG: /* UpsertRowParamValue */1,
          _0: {
            spreadsheetId: match$1.spreadsheetId,
            sheetName: match$1.sheetName,
            keyColumnIndex: match$1.keyColumnIndex,
            keyColumnValue: match$1.keyColumnValue,
            colNames: match$1.colNames,
            rowData: match$1.rowData
          }
        };
}

function toPlaybackCommandValue(param) {
  if (param.TAG === /* UpdateCellParamValue */0) {
    var match = param._0;
    return {
            spreadsheetId: match.spreadsheetId,
            sheetName: match.sheetName,
            colNames: match.colNames,
            update: {
              TAG: /* UpdateCell */1,
              _0: {
                rowLocation: {
                  keyColumnIndex: match.keyColumnIndex,
                  keyColumnValue: match.keyColumnValue
                },
                updatedColIndex: match.updatedColIndex,
                cellUpdate: match.cellUpdate
              }
            }
          };
  }
  var match$1 = param._0;
  return {
          spreadsheetId: match$1.spreadsheetId,
          sheetName: match$1.sheetName,
          colNames: match$1.colNames,
          update: {
            TAG: /* UpsertRow */0,
            _0: {
              rowLocation: {
                keyColumnIndex: match$1.keyColumnIndex,
                keyColumnValue: match$1.keyColumnValue
              },
              cellValues: match$1.rowData
            }
          }
        };
}

var PlaybackParamValue = {
  UpdateCellParamValue: UpdateCellParamValue,
  UpsertRowParamValue: UpsertRowParamValue,
  t_encode: t_encode$18,
  t_decode: t_decode$18,
  stringify: stringify$12,
  fromParamDescriptor: fromParamDescriptor,
  toPlaybackCommandValue: toPlaybackCommandValue
};

exports.A1 = A1;
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue;
/* @segment/a1-notation Not a pure module */
